import { adminsRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.SUPER_ADMIN];

const adminsRouteMetadata: IRouteMetadataObj<typeof adminsRoutesObj> = {
  create: {
    title: "users.admin.create.title",
    description: "users.admin.create.description",
    lazy: () => import("@/pages/userManagement/admins/form/page"),
    mode: "create",
    type: "inner",
    icon: "AddLine",
    breadcrumbs: [],
    permission,
  },
  edit: {
    title: "users.admin.edit.title",
    description: "users.admin.edit.description",
    lazy: () => import("@/pages/userManagement/admins/form/page"),
    mode: "edit",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    permission,
  },
};

export const adminsRoutes = createRoute<typeof adminsRoutesObj>(
  adminsRoutesObj,
  adminsRouteMetadata,
);
